import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAllFuelling(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    //.get('/apps/user/users', { params: queryParams })
                    .get(`/api/v1/Fuelling/search?AssetId=${queryParams.assetId}&Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}&Start=${queryParams.dtS}&End=${queryParams.dtE}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchFuelling(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Fuelling?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addFuelling(ctx, fuellingData) {
            return new Promise((resolve, reject) => {

                let fuelling = fuellingData.fuellingData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/fuelling', fuelling)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }, //
        importFuelling(ctx, fuelling) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append("file", fuelling);
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/integrations/file/UploadTicketLogFuellingFile', formData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateFuelling(ctx, fuellingData) {
            return new Promise((resolve, reject) => {

                let fuelling = fuellingData.fuellingData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .put('/api/v1/fuelling', fuelling)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteFuelling(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {

                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/fuelling?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchTypeFuel(ctx,) {
            return new Promise((resolve, reject) => {

                axios
                    .get('/api/v1/Fuelling/searchfueltype?Page=1&PerPage=11')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssets(ctx, queryParams = {}) {
            return new Promise((resolve, reject) => {
                const excludeGrouped = queryParams.excludeGrouped ? `&ExcludeGrouped=${queryParams.excludeGrouped}` : ''
                const q = queryParams.q !== undefined && queryParams.q !== null ? queryParams.q : ''
                const page = queryParams.page || 1
                const perPage = queryParams.perPage || 10

                axios
                    .get(`/api/v1/Asset/search?Search=${q}${excludeGrouped}&Page=${page}&PerPage=${perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },


        //Preventive Maintenance Plan
        fetchAllMaintenancePlan(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Maintenance/SearchPreventiveMaintenancePlan?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchMaintenancePlan(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Maintenance/GetPreventiveMaintenancePlan?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addMaintenancePlan(ctx, maintenanceData) {
            return new Promise((resolve, reject) => {
                let maintenance = maintenanceData.maintenanceData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Maintenance/CreatePreventiveMaintenancePlan', maintenance)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateMaintenancePlan(ctx, maintenanceData) {
            return new Promise((resolve, reject) => {
                let maintenance = maintenanceData.maintenanceData
                axios
                    .put('/api/v1/Maintenance/UpdatePreventiveMaintenancePlan', maintenance)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteMaintenancePlan(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/v1/Maintenance/DeletePreventiveMaintenancePlan?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteMaintenancePlanStep(ctx, {
            preventiveMaintenancePlanId,
            preventiveMaintenanceId
        }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/v1/Maintenance/DeletePreventiveMaintenancePlanStep?preventiveMaintenancePlanId=${preventiveMaintenancePlanId}&preventiveMaintenanceId=${preventiveMaintenanceId}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        downloadMaintenancePlanStepsModel() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/v1/Maintenance/DownloadImportPreventiveMaintenancePlanStepsFileModel', {
                        responseType: 'blob',
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        uploadMaintenancePlanSteps(ctx, { preventiveMaintenancePlanId, file }) {
            return new Promise((resolve, reject) => {
                const formData = new FormData()
                formData.append('file', file)
                axios
                    .post(`/api/v1/Maintenance/UploadImportPreventiveMaintenancePlanSteps?preventiveMaintenancePlanId=${preventiveMaintenancePlanId}`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        //fetchPlansByAssetId
        fetchPlansByAssetId(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Maintenance/SearchPreventiveMaintenancePlanOfAsset?AssetId=${queryParams.assetId}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        bindMaintenancePlan(ctx, bindMaintenance) {
            return new Promise((resolve, reject) => {

                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Maintenance/BindPreventiveMaintenancePlan', bindMaintenance)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteBindPlan(ctx, bindPlan) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/v1/Maintenance/UnbindPreventiveMaintenancePlan?AssetId=${bindPlan.assetId}&PreventiveMaintenancePlanId=${bindPlan.preventiveMaintenancePlanId}&AssetMaintenancePlanId=${bindPlan.assetMaintenancePlanId}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchAssetsByPlanId(ctx, query) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Maintenance/SearchAssetOfPreventiveMaintenancePlan?PreventiveMaintenancePlanId=${query.planId}&Page=${query.page}&PerPage=${query.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchMaintenancePlanSummary(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Maintenance/GetAssetMaintenancePlanSummary?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        ///api/v1/Asset/searchassetgroup
        fetchAllGroup(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams()
                if (queryParams.page) params.append('page', queryParams.page)
                if (queryParams.perPage) params.append('perPage', queryParams.perPage)
                if (queryParams.q) params.append('search', queryParams.q)
                if (queryParams.customerId) params.append('customerId', queryParams.customerId)
                if (queryParams.includeSubcustomers !== undefined && queryParams.includeSubcustomers !== null) {
                    params.append('includeSubcustomers', queryParams.includeSubcustomers)
                }

                axios
                    .get('/api/v1/Asset/searchassetgroup', { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchCustomers(ctx, queryParams = {}) {
            return new Promise((resolve, reject) => {
                const search = queryParams.q !== undefined && queryParams.q !== null ? queryParams.q : ''
                axios
                    .get(`/api/v1/Customer/search?Search=${search}&Page=1&PerPage=5`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addGroup(ctx, groupData) {
            return new Promise((resolve, reject) => {

                let group = groupData.groupData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/createassetgroup', group)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchGroup(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Asset/getassetgroup?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchAssetsOfAssetGroup(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/SearchAssetsOfAssetGroup?AssetGroupId=${queryParams.groupId}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        bindAssetToAssetGroup(ctx, bind) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/BindAssetToAssetGroup', bind)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        ///api/v1/Asset/deleteassetgroup
        deletAassetGroup(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/v1/Asset/deleteassetgroup?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateassetgroup(ctx, group) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .put('/api/v1/Asset/updateassetgroup', { id: group.id, name: group.name, description: group.description, alertEmails: Array.isArray(group.alertEmails) ? group.alertEmails : [] }, { headers: { 'Content-Type': 'application/json' } })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },


        unBindAssetToAssetGroup(ctx, group) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/v1/Asset/UnBindAssetToAssetGroup?AssetId=${group.assetId}&AssetGroupId=${group.assetGroupId ?? ""}&BindId=${group.bindId ?? ""}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },


        fetchAsset(ctx, {
            id
        }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Asset?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addMaintenance(ctx, maintenance) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/Maintenance/createmaintenance', maintenance.maintenanceData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateMaintenance(ctx, maintenanceData) {
            return new Promise((resolve, reject) => {
                let maintenance = maintenanceData.maintenanceData
                axios
                    .put('/api/v1/Maintenance/updatemaintenance', maintenance)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addMaintenanceItemType(ctx, maintenanceItemType) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Maintenance/createmaitenanceitemtype', maintenanceItemType.maintenanceItemType)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchSearchMaintenanceItemType(ctx, {query, page, perPage}) {
            return new Promise((resolve, reject) => {
                axios
                    //.get('/apps/user/users', { params: queryParams })
                    .get(`/api/v1/Maintenance/searchmaintenanceitemstype?Search=${query}&Page=${page}&PerPage=${perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchPreventiveMaintenances(ctx, {assetId, search, page, perPage}) {
            return new Promise((resolve, reject) => {
                axios
                    //.get('/apps/user/users', { params: queryParams })
                    .get(`/api/v1/Maintenance/SearchPreventiveMaintenances?AssetId=${assetId}&Search=${search}&Page=${page}&PerPage=${perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchMaintenances(ctx, {assetId, search, page, perPage}) {
            return new Promise((resolve, reject) => {

                axios.get('/api/v1/Maintenance/SearchMaintenance', {
                    params: {
                        AssetId: assetId,
                        Search: search,
                        Page: page,
                        PerPage: perPage,
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchMaintenance(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Maintenance/GetMaintenance?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchMaintenanceTimeReport(ctx, {customerId, assetBrandId, assetTypeId, assetModelId, start, end, page, perPage = 10, search = ""}) {
            return new Promise((resolve, reject) => {

                axios.get('/api/v1/queries/maintenance/MaintenanceTimeReport', {
                    params: {
                        Search: search,
                        CustomerId: customerId,
                        AssetBrandId: assetBrandId,
                        AssetTypeId: assetTypeId,
                        AssetModelId: assetModelId,
                        Start: start,
                        End: end,
                        Page: page,
                        PerPage: perPage,
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
